import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const VrkIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99583)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM3.911 21.717H5.531L8.223 14.201H6.613L4.773 19.764L2.87 14.2H1.225L3.911 21.717ZM8.542 21.717H10.06V18.58H10.368C10.716 18.58 10.971 18.608 11.132 18.664C11.292 18.721 11.444 18.824 11.588 18.977C11.731 19.129 11.998 19.497 12.388 20.082L13.485 21.717H15.3L14.382 20.251C14.02 19.667 13.732 19.26 13.518 19.031C13.2794 18.7826 13.0059 18.5704 12.706 18.401C13.366 18.304 13.861 18.073 14.192 17.705C14.524 17.338 14.69 16.872 14.69 16.308C14.69 15.864 14.58 15.469 14.362 15.124C14.1596 14.7924 13.8513 14.5388 13.487 14.404C13.123 14.269 12.54 14.201 11.737 14.201H8.542V21.717ZM10.06 17.38V15.473H11.244C11.86 15.473 12.229 15.481 12.352 15.498C12.598 15.539 12.788 15.638 12.923 15.793C13.058 15.949 13.126 16.153 13.126 16.406C13.1333 16.6053 13.0796 16.8021 12.972 16.97C12.8697 17.1203 12.7201 17.2323 12.547 17.288C12.365 17.349 11.911 17.38 11.183 17.38H10.06ZM15.68 21.717H17.198V19.446L18.428 18.19L20.495 21.717H22.458L19.475 17.129L22.305 14.201H20.265L17.198 17.539V14.2H15.681V21.716L15.68 21.717ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99583'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

VrkIcon.displayName = 'VrkIcon'
